import { get } from "lodash";
import _ from "lodash";
import { IFieldArray, IFieldGroup } from "AngularFormly";
import fieldHelpers from "../../../ui-formly/fieldHelpers";
import {
  FieldConfigurationHelperService,
  vsName as FieldConfigurationHelperServiceName,
} from "../../../records/forms/formly/fieldConfigurationHelpers";
import { LookupManagementService } from "../../../records/lookup/lookupManagement";
import { vsObjectName as contactType } from "../configs/contractContactType";
import { vsObjectName as contractStatusName } from "../configs/contractStatus";
import { vsObjectName as contractRenewalTypeName } from "../configs/contractRenewalType";
import { vsObjectName as contractNumberTypeName } from "../configs/contractNumberType";
import { vsLookupManagementServiceName } from "../lookupManagement";
import { machineManufacturerName } from "../../../machines/shared/names";
import { vsLookupManagementServiceName as machineLookupManagementServiceName } from "../../../machines/shared/lookups";

export const vsServiceName = "contractInstanceFieldsService";

export class ContractInstanceFieldsService {
  static $inject = [
    FieldConfigurationHelperServiceName,
    vsLookupManagementServiceName,
    machineLookupManagementServiceName,
  ];
  constructor(
    private readonly fieldConfigurationHelperService: FieldConfigurationHelperService,
    private readonly contractLookupManagementService: LookupManagementService,
    private readonly machineLookupMangementService: LookupManagementService
  ) {}

  contractInstanceFields(): IFieldGroup[] {
    return fieldHelpers.columnLayout(
      [
        fieldHelpers.simpleStringField({
          key: "ContractNumber",
          name: "ContractNumber",
          label: "Contract Number",
          required: true,
        }),

        fieldHelpers.simpleDateField({
          key: "ContractStartDate",
          name: "ContractStartDate",
          label: "Contract Start",
          required: true,
        }),

        fieldHelpers.simpleDateField({
          key: "ContractEndDate",
          name: "ContractEndDate",
          label: "Contract End",
        }), 

        this.fieldConfigurationHelperService.lookupField(
          this.contractLookupManagementService,
          {
            objectName: contractStatusName,
            key: "ContractStatusId",
            required: true,
          }
        ),
        this.fieldConfigurationHelperService.selectAsyncField({
          key: "ContractPropertyId",
          name: "ContractPropertyId",
          label: "Property",
          required: true,
          disableDefaultQueryCaching: true,
          getDefaultItem: (model) =>
            FieldConfigurationHelperService.getDefaultItem(
              get(model, "ContractProperty")
            ),
          queryUrl: "/api/properties",
        }),
        this.fieldConfigurationHelperService.lookupField(
          this.machineLookupMangementService,
          {
            objectName: machineManufacturerName,
            key: "ContractMachineManufacturerId",
            required: true,
          }
        ),
        this.fieldConfigurationHelperService.lookupField(
          this.contractLookupManagementService,
          {
            key: "ContractRenewalTypeId",
            objectName: contractRenewalTypeName,
          }
        ),
      ],
      4
    );
  }

  contractInstanceFileFields(): IFieldArray {
    return [
      this.fieldConfigurationHelperService.repeaterField({
        key: "ContractNumbers",
        allowAdd: true,
        allowAddBottom: false,
        displayNameSingular: "Contract Number",
        displayNamePlural: "Contract Numbers",
        showHeader: true,
        label: "Contract Numbers",
        repeaterFields: fieldHelpers.columnLayout(
          [
            this.fieldConfigurationHelperService.lookupField(
              this.contractLookupManagementService,
              {
                key: "ContractNumberTypeId",
                label: "Number Type",
                objectName: contractNumberTypeName,
                required: true,
              }
            ),
            fieldHelpers.simpleStringField({
              key: "Number",
              label: "Number",
              required: true,
            }),
          ],
          4
        ),
      }),
      ...fieldHelpers.columnLayout([], 4),
      {
        key: "Files",
        name: "Files",
        type: "recordFileUpload",
        templateOptions: {
          label: "Source Documents",
          allowMultiple: true,
        },
      },
      ...fieldHelpers.columnLayout(
        [
          {
            key: "ExecutedContract",
            name: "ExecutedContract",
            type: "fileUploadSingle",
            templateOptions: {
              label: "Executed Contract",
            },
          },
        ],
        1
      ),
      fieldHelpers.headerField({
        headerText: "Notes",
        key: "NotesHeader",
      }),
      fieldHelpers.textAreaField({
        key: "Notes",
        name: "Notes",
        label: " ",
        rows: 5,
      }),
    ];
  }

  contractInstanceContactField(): IFieldArray {
    return [
      this.fieldConfigurationHelperService.repeaterField({
        key: "Contacts",
        name: "Contacts",
        label: "Vendor Information",
        allowAdd: true,
        allowAddBottom: true,
        displayNameSingular: "Contact",
        displayNamePlural: "Vendor Information",
        repeaterFields: [
          ...fieldHelpers.columnLayout(
            [
              this.fieldConfigurationHelperService.lookupField(
                this.contractLookupManagementService,
                {
                  key: "ContractContactTypeId",
                  objectName: contactType,
                  required: false,
                }
              ),
              this.fieldConfigurationHelperService.selectAsyncField({
                key: "AddressBookId",
                name: "AddressBookId",
                label: "Contact",
                required: true,
                getDefaultItem: (model) =>
                  FieldConfigurationHelperService.getDefaultItem(
                    get(model, "AddressBook")
                  ),
                serverItemMapper(model) {
                  return {
                    Id: model?.Id,
                    Name: model?.AddressBookName,
                  };
                },
                queryUrl: "/api/addressBook/addressBook",
              }),
              {
                key: "copyDelete",
                type: "recordRepeaterCopyDelete",
                templateOptions: {
                  label: " ",
                  allowMove: true,
                },
              },
            ],
            4
          ),
        ],
        showHeader: true,
      }),
    ];
  }
}
 